// Detecção de AMBIENTE do frontend (sandbox vs. o resto).
//
// POR QUÊ derivar do HOSTNAME e não de um `REACT_APP_*`: o Portal NÃO injeta um
// rótulo de ambiente no build. O único `REACT_APP_*` que varia por ambiente é
// `REACT_APP_BACKEND_URL` (uma URL de API — `lib/api.js` — não um rótulo de
// ambiente). O que define o ambiente é ONDE o front é servido:
//   - SANDBOX  → `sandbox.parceiros.zemocapital.com`  (infra/terraform/frontend_cdn.tf)
//   - PRODUÇÃO → `parceiros.zemocapital.com` / `clientes.zemocapital.com` (infra/DEPLOY_GUIDE.md)
// Derivar do hostname é FAIL-CLOSED e sem dependência de build a acertar: só o
// subdomínio `sandbox.` liga o sinal; QUALQUER outro host (prod, preview,
// localhost) ⇒ NÃO-sandbox. Assim o badge nunca aparece em prod por engano.

// Prefixo do host do ambiente sandbox. Ponto único caso o subdomínio mude.
export const SANDBOX_HOST_PREFIX = "sandbox.";

/**
 * O host informado é o do ambiente SANDBOX?
 *
 * FAIL-CLOSED: true SÓ quando o hostname começa com `sandbox.` (o sandbox é um
 * subdomínio dedicado — startsWith, não substring: `mysandbox.` ou
 * `app.sandbox.` NÃO contam). Ausência/valor não-string ⇒ false.
 */
export function isSandboxHost(hostname) {
  const h = String(hostname == null ? "" : hostname).toLowerCase();
  return h.startsWith(SANDBOX_HOST_PREFIX);
}

/**
 * Estamos rodando no ambiente SANDBOX agora? Lê o hostname do browser.
 * Sem `window`/`location` (SSR, teste sem DOM) ⇒ false (fail-closed).
 */
export function isSandboxEnv() {
  if (typeof window === "undefined" || !window.location) return false;
  return isSandboxHost(window.location.hostname);
}
